interface MiniMacTitleBarProps {
  title?: string;
}

export function MiniMacTitleBar({ title = 'Arvid' }: MiniMacTitleBarProps) {
  return (
    <div className="demo-mac-title-bar relative flex items-center justify-center shrink-0 bg-surface-panel border-b border-border-subtle">
      <div className="demo-mac-traffic-lights absolute top-1/2 -translate-y-1/2 flex items-center">
        <span className="demo-mac-traffic-light demo-mac-traffic-light-close rounded-full" />
        <span className="demo-mac-traffic-light demo-mac-traffic-light-minimize rounded-full" />
        <span className="demo-mac-traffic-light demo-mac-traffic-light-maximize rounded-full" />
      </div>
      <span className="text-[7px] font-[var(--fw-medium)] text-text-primary">{title}</span>
    </div>
  );
}
